import { render, staticRenderFns } from "./saleTaxTemplateCreate.vue?vue&type=template&id=e59c6ec0&scoped=true"
import script from "./saleTaxTemplateCreate.vue?vue&type=script&lang=js"
export * from "./saleTaxTemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./saleTaxTemplateCreate.vue?vue&type=style&index=0&id=e59c6ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59c6ec0",
  null
  
)

export default component.exports